import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { FormikProps } from 'formik';
import { Fragment, memo, useEffect, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { PersonFormVM } from '../person/form';
import TableFamilyForm, { FamilyVM } from './table-family';

interface AccordionFormFamilyProps {
  formContext: FormikProps<{
    family: Array<FamilyVM>;
    person?: PersonFormVM;
  }>;
  idAnprIntestatario?: boolean;
  disabledAll?: boolean;
  disabled?: boolean;
  codeEnte?: string;
  yearId?: string;
  typeRegister?: string;
  progressive?: string;
  typePractice?: string;
  disabledResidente?: boolean;
}

const AccordionFamilyComponent = ({
  formContext,
  disabledAll = false,
  idAnprIntestatario = false,
  disabled = false,
  codeEnte,
  yearId,
  typeRegister,
  progressive,
  typePractice,
  disabledResidente,
}: AccordionFormFamilyProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen((oldState) => {
      if (idAnprIntestatario && !oldState) {
        return true;
      }

      return oldState;
    });
  }, [idAnprIntestatario]);

  return (
    <Fragment>
      <Accordion
        expanded={open}
        onChange={() => {
          if (idAnprIntestatario) setOpen(!open);
        }}
      >
        <AccordionSummary
          aria-controls="panel-family-practice-content"
          id="panel-family-practice-header"
          expandIcon={<ExpandMore />}
        >
          <Typography>Famiglia</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <TableFamilyForm
            values={formContext.values.family}
            disabledAll={disabledAll}
            onChange={(values) => formContext.setFieldValue('family', values)}
            disabled={disabled}
            codeEnte={codeEnte}
            yearId={yearId}
            typeRegister={typeRegister}
            progressive={progressive}
            typePractice={typePractice}
            disabledResidente={disabledResidente}
          />
        </AccordionDetails>
      </Accordion>
    </Fragment>
  );
};

AccordionFamilyComponent.displayName = 'Accordion Family component';

const AccordionFamily = memo(AccordionFamilyComponent);

export default AccordionFamily;
